import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import Loadable from '../layouts/loader/Loadable';
import { Private, PrivateLogin } from './PrivateRoute';
import ProtectedRoute, { AcessoNegado } from '../components/permissoes/ProtectedRoute';
import ConfigVendasGuard from './ConfigVendasGuard';
import ConfigLocalStorageGuard from './ConfigLocalStorageGuard';
import FerramentaGuard from './FerramentaGuard';
/****Layouts*****/

const FullLayout = Loadable(lazy(() => import('../layouts/FullLayout')));
const BlankLayout = Loadable(lazy(() => import('../layouts/BlankLayout')));
/***** Pages ****/


/***** Login ****/
const LoginFormik = Loadable(lazy(() => import('../pages/login/LoginFormik')));


/****Inicio****/
const Dashboard = Loadable(lazy(() => import('../pages/inicio/dashboard/Dashboard')));
const Agenda = Loadable(lazy(() => import('../pages/inicio/agenda/Agenda')));
const Conta = Loadable(lazy(() => import('../pages/inicio/conta/Conta')));
const Integracao = Loadable(lazy(() => import('../pages/inicio/integracao/Integracao')));
const IntegracaoDetalhe = Loadable(lazy(() => import('../pages/inicio/integracao/IntegracaoDetalhe')));
// eslint-disable-next-line no-unused-vars
const Onboarding = Loadable(lazy(() => import('../pages/inicio/onboarding/Onboarding')));
const Alertas = Loadable(lazy(() => import('../pages/inicio/alertas/Alertas')));
const AlertasRegras = Loadable(lazy(() => import('../pages/inicio/alertas/AlertasRegras')));
const ReguaCobranca = Loadable(lazy(() => import('../pages/financas/cobranca/ReguaCobranca')));
const ReguaCobrancaHistorico = Loadable(lazy(() => import('../pages/financas/cobranca/ReguaCobrancaHistorico')));
const RecomendacaoCompra = Loadable(lazy(() => import('../pages/suprimentos/recomendacao/RecomendacaoCompra')));
const RecomendacaoConfig = Loadable(lazy(() => import('../pages/suprimentos/recomendacao/RecomendacaoConfig')));
const DashboardPreditivo = Loadable(lazy(() => import('../pages/inicio/dashboard-preditivo/DashboardPreditivo')));
const DashboardPreditivoConfig = Loadable(lazy(() => import('../pages/inicio/dashboard-preditivo/DashboardPreditivoConfig')));
const Extensao = Loadable(lazy(() => import('../pages/inicio/extensao/Extensao')));
const Upgrade = Loadable(lazy(() => import('../pages/inicio/upgrade/Upgrade')));
const Versao = Loadable(lazy(() => import('../pages/inicio/versao/Versao')));
const Ajuda = Loadable(lazy(() => import('../pages/inicio/ajuda/Ajuda')));
const Ferramentas = Loadable(lazy(() => import('../pages/inicio/ferramentas/Ferramentas')));

/****Cadastros****/
const Pessoas = Loadable(lazy(() => import('../pages/cadastros/pessoas/Pessoas')));
const Produtos = Loadable(lazy(() => import('../pages/cadastros/produtos/Produtos')));
const Categoria = Loadable(lazy(() => import('../pages/cadastros/categoria/Categoria')));
const Subcategoria = Loadable(lazy(() => import('../pages/cadastros/subcategoria/Subcategoria')));
const Marca = Loadable(lazy(() => import('../pages/cadastros/marca/Marca')));
const Unidade = Loadable(lazy(() => import('../pages/cadastros/unidade/Unidade')));
// eslint-disable-next-line no-unused-vars
const Embalagem = Loadable(lazy(() => import('../pages/cadastros/embalagem/Embalagem')));
const Funcionarios = Loadable(lazy(() => import('../pages/cadastros/funcionarios/Funcionarios')));
const Relatorioscad = Loadable(lazy(() => import('../pages/cadastros/relatorioscad/Relatorioscad')));

/****Suprimentos****/
const Estoques = Loadable(lazy(() => import('../pages/suprimentos/estoques/Estoques')));
const Compras = Loadable(lazy(() => import('../pages/suprimentos/compras/Compras')));
const Entradas = Loadable(lazy(() => import('../pages/suprimentos/entradas/Entradas')));
const Recebimento = Loadable(lazy(() => import('../pages/suprimentos/recebimento/Recebimentocompra')));
const Relatorios = Loadable(lazy(() => import('../pages/suprimentos/relatorios/Relatorios')));
// eslint-disable-next-line no-unused-vars
const ManifestoDestinatario = Loadable(lazy(() => import('../pages/suprimentos/manifesto/ManifestoDestinatario')));
const Transferencia = Loadable(lazy(() => import('../pages/suprimentos/transferencia/Transferencia')));
const GerenciamentoPrecos = Loadable(lazy(() => import('../pages/suprimentos/gerenciamentoprecos/GerenciamentoPrecos')));


/****Vendas****/
const Pdv = Loadable(lazy(() => import('../pages/vendas/pdv/Pdv')));
const Pedidos = Loadable(lazy(() => import('../pages/vendas/pedidos/Pedidos')));
const OrdemServico = Loadable(lazy(() => import('../pages/vendas/ordemservico/OrdemServico')));
const ContratosVenda = Loadable(lazy(() => import('../pages/vendas/contratos/Contratos')));
const VendaRapida = Loadable(lazy(() => import('../pages/vendas/vendarapida/VendaRapida')));
const Comissoes = Loadable(lazy(() => import('../pages/vendas/comissoes/Comissoes')));
const Relatoriosvendas = Loadable(lazy(() => import('../pages/vendas/relatoriosvendas/Relatoriosvendas')));
// eslint-disable-next-line no-unused-vars
const CuponsFiscais = Loadable(lazy(() => import('../pages/vendas/cuponsfiscais/CuponsFiscais')));


/****Finanças****/
const Caixa = Loadable(lazy(() => import('../pages/financas/caixa/Caixa')));
const Contaspagar = Loadable(lazy(() => import('../pages/financas/contaspagar/Contaspagar')));
const Contasreceber = Loadable(lazy(() => import('../pages/financas/contasreceber/Contasreceber')));
const Planoconta = Loadable(lazy(() => import('../pages/financas/planoconta/Planoconta')));
const Cobrancas = Loadable(lazy(() => import('../pages/financas/cobrancas/Cobrancas')));
const Extratos = Loadable(lazy(() => import('../pages/financas/extratos/Extratos')));
const Relatoriosfinancas = Loadable(lazy(() => import('../pages/financas/relatoriosfinancas/Relatoriosfinancas')));


/****Serviços****/
const Contratos = Loadable(lazy(() => import('../pages/servicos/contratos/Contratos')));
const Notas = Loadable(lazy(() => import('../pages/servicos/notas/Notas')));
const Cobrancasservico = Loadable(lazy(() => import('../pages/servicos/cobrancasservico/Cobrancasservico')));
const Relatoriosservico = Loadable(lazy(() => import('../pages/servicos/relatoriosservico/Relatoriosservico')));

/****PCP****/
const FichaTecnica = Loadable(lazy(() => import('../pages/pcp/fichatecnica/FichaTecnica')));
const OrdemProducao = Loadable(lazy(() => import('../pages/pcp/ordemproducao/OrdemProducao')));
const NecessidadeMaterial = Loadable(lazy(() => import('../pages/pcp/necessidade/NecessidadeMaterial')));
const ConfiguracaoPCP = Loadable(lazy(() => import('../pages/configuracoes/configpcp/ConfiguracaoPCP')));
const ConfiguracaoVendas = Loadable(lazy(() => import('../pages/configuracoes/configvendas/ConfiguracaoVendas')));
const ConfiguracaoProduto = Loadable(lazy(() => import('../pages/configuracoes/configproduto/ConfiguracaoProduto')));
const ConfiguracaoExpedicao = Loadable(lazy(() => import('../pages/configuracoes/configexpedicao/ConfiguracaoExpedicao')));

/****Expedição****/
// eslint-disable-next-line no-unused-vars, import/extensions
const Separacao = Loadable(lazy(() => import('../pages/expedicao/separacao/Separacao')));
// eslint-disable-next-line no-unused-vars, import/extensions
const Romaneio = Loadable(lazy(() => import('../pages/expedicao/romaneio/Romaneio')));
// eslint-disable-next-line no-unused-vars, import/extensions
const SaidaProduto = Loadable(lazy(() => import('../pages/expedicao/saida/SaidaProduto')));

/****Configuração****/
const Configuracaoes = Loadable(lazy(() => import('../pages/configuracoes/Configuracoes')));
const Configempresaefilial = Loadable(lazy(() => import('../pages/configuracoes/configempresaefilial/Configempresaefilial')));
const Cadusuariosistema = Loadable(lazy(() => import('../pages/configuracoes/cadusuariosistema/Cadusuariosistema')));
const Configuracaoordemcompra = Loadable(lazy(() => import('../pages/configuracoes/configordemcompra/Configuracaoordemcompra')));
const Perfis = Loadable(lazy(() => import('../pages/configuracoes/perfis/Perfis')));
const Configuracaocomissao = Loadable(lazy(() => import('../pages/configuracoes/configcomissao/Configuracaocomissao')));
// eslint-disable-next-line import/extensions
const Configtaxacartao = Loadable(lazy(() => import('../pages/configuracoes/configtaxacartao/Configtaxacartao')));
// eslint-disable-next-line no-unused-vars
const Configboleto = Loadable(lazy(() => import('../pages/configuracoes/configboleto/Configboleto')));
// eslint-disable-next-line no-unused-vars
const ConfigCreditoLoja = Loadable(lazy(() => import('../pages/configuracoes/configcreditoloja/ConfigCreditoLoja')));
// eslint-disable-next-line no-unused-vars
const BaixaCreditoLoja = Loadable(lazy(() => import('../pages/financas/creditoloja/BaixaCreditoLoja')));
const ConfigAnaliseCredito = Loadable(lazy(() => import('../pages/configuracoes/configanalisecredito/ConfigAnaliseCredito')));
const AnaliseCredito = Loadable(lazy(() => import('../pages/financas/analisecredito/AnaliseCredito')));
const GerenciarLojas = Loadable(lazy(() => import('../pages/configuracoes/lojas/GerenciarLojas')));
const LogAuditoria = Loadable(lazy(() => import('../pages/configuracoes/logauditoria/LogAuditoria')));
// eslint-disable-next-line no-unused-vars
const ImportacaoProdutos = Loadable(lazy(() => import('../pages/configuracoes/importacao/ImportacaoProdutos')));
// eslint-disable-next-line no-unused-vars
const ImportacaoClientes = Loadable(lazy(() => import('../pages/configuracoes/importacao/ImportacaoClientes')));
const ImportacaoNCM = Loadable(lazy(() => import('../pages/configuracoes/importacao/ImportacaoNCM')));
const ImportacaoPedidoVenda = Loadable(lazy(() => import('../pages/configuracoes/importacao/ImportacaoPedidoVenda')));
const ImportacaoListaFornecedor = Loadable(lazy(() => import('../pages/configuracoes/importacao/ImportacaoListaFornecedor')));
// eslint-disable-next-line import/extensions
const DiagnosticoFiscal = Loadable(lazy(() => import('../pages/fiscal/DiagnosticoFiscal')));
const RegrasConversao = Loadable(lazy(() => import('../pages/fiscal/RegrasConversao')));
const InutilizacaoNumeracao = Loadable(lazy(() => import('../pages/fiscal/InutilizacaoNumeracao')));
// eslint-disable-next-line import/extensions
const ImportarXMLEntrada = Loadable(lazy(() => import('../pages/suprimentos/entradas/ImportarXMLEntrada')));
// eslint-disable-next-line import/extensions
const EntradaDetalhe = Loadable(lazy(() => import('../pages/suprimentos/entradas/EntradaDetalhe')));

/****Admin - Super Admin****/
const GerenciarClientes = Loadable(lazy(() => import('../pages/admin/clientes/GerenciarClientes')));

/****Fiscal - Configurações****/
const ConfigFiscalPage = Loadable(lazy(() => import('../pages/fiscal/ConfigFiscal')));
const ConfigFiscalEmpresa = Loadable(lazy(() => import('../pages/fiscal/ConfigFiscalEmpresa')));

/****Fiscal - Reforma Tributária****/
const NCMReforma = Loadable(lazy(() => import('../pages/fiscal/NCMReforma')));
const ClassTribConsulta = Loadable(lazy(() => import('../pages/fiscal/ClassTribConsulta')));
const RevisaoTributaria = Loadable(lazy(() => import('../pages/fiscal/RevisaoTributaria')));
const AliquotasUF = Loadable(lazy(() => import('../pages/fiscal/AliquotasUF')));

/****Fiscal - Cadastros Base****/
const CFOP = Loadable(lazy(() => import('../pages/fiscal/CFOP')));
const NaturezaOperacao = Loadable(lazy(() => import('../pages/fiscal/NaturezaOperacao')));
const ClassTrib = Loadable(lazy(() => import('../pages/fiscal/ClassTrib')));
const CST = Loadable(lazy(() => import('../pages/fiscal/CST')));

/****Fiscal - Parametrização****/
const OperacoesFiscais = Loadable(lazy(() => import('../pages/fiscal/OperacoesFiscais')));
const RegraICMSUF = Loadable(lazy(() => import('../pages/fiscal/RegraICMSUF')));

/****Fiscal - Nota Fiscal Eletrônica****/
const NotaFiscalEletronica = Loadable(lazy(() => import('../pages/fiscal/nfe/NotaFiscalEletronica')));

/****Fiscal - NFS-e (Padrão Nacional)****/
// eslint-disable-next-line no-unused-vars
const NotaFiscalServico = Loadable(lazy(() => import('../pages/fiscal/nfse/NotaFiscalServico')));

/****Fiscal - Dashboard e Relatórios****/
// eslint-disable-next-line no-unused-vars
const DashboardFiscal = Loadable(lazy(() => import('../pages/fiscal/DashboardFiscal')));
// eslint-disable-next-line no-unused-vars
const RelatorioNFe = Loadable(lazy(() => import('../pages/fiscal/RelatorioNFe')));
// eslint-disable-next-line no-unused-vars
const RelatorioNFCe = Loadable(lazy(() => import('../pages/fiscal/RelatorioNFCe')));

/*****Suporte*****/
const Suporte = Loadable(lazy(() => import('../pages/suporte/Suporte')));

/*****Perfil*****/
const MeuPerfil = Loadable(lazy(() => import('../pages/perfil/MeuPerfil')));
const EditarPerfil = Loadable(lazy(() => import('../pages/perfil/EditarPerfil')));

/*****Design System (dev-only)*****/
// eslint-disable-next-line no-unused-vars
const DesignSystem = Loadable(lazy(() => import('../pages/design-system/DesignSystem')));


/***** Auth Pages ****/
const Error = Loadable(lazy(() => import('../views/auth/Error')));
const RegisterFormik = Loadable(lazy(() => import('../views/auth/RegisterFormik')));
//const LoginFormik = Loadable(lazy(() => import('../views/auth/LoginFormik')));
const Maintanance = Loadable(lazy(() => import('../views/auth/Maintanance')));
const LockScreen = Loadable(lazy(() => import('../views/auth/LockScreen')));
const RecoverPassword = Loadable(lazy(() => import('../views/auth/RecoverPassword')));

/*****Routes******/

const ThemeRoutes = [
  {
    path: '/',
    element: <BlankLayout />,
    children: [
      //login  
      { path: '/',name: 'login', element: <PrivateLogin><LoginFormik /></PrivateLogin> },      
    ],
  },
  {
    path: '/',
    element: <FullLayout />,
    children: [

      //início
      //{ path: '/inicio/indice', name: 'Indice', exact: true, element: <Private> <Indice /> </Private>  },
      { path: '/inicio/dashboard', name: 'Inicio', exact: true, element: <Private> <Dashboard /> </Private>  },
      { path: '/inicio/agenda', name: 'Agenda', exact: true, element: <Private> <Agenda /> </Private>  },
      { path: '/inicio/conta', name: 'Conta', exact: true, element: <Private> <Conta /> </Private>  },
      { path: '/inicio/integracao', name: 'Integracao', exact: true, element: <Private> <FerramentaGuard flag="integracoes"><Integracao /></FerramentaGuard> </Private>  },
      { path: '/inicio/integracao/:id', name: 'Integracao Detalhe', exact: true, element: <Private> <FerramentaGuard flag="integracoes"><IntegracaoDetalhe /></FerramentaGuard> </Private>  },
      { path: '/inicio/onboarding', name: 'Configuracao Inicial', exact: true, element: <Private> <FerramentaGuard flag="onboarding"><Onboarding /></FerramentaGuard> </Private>  },
      { path: '/alertas', name: 'Alertas', exact: true, element: <Private> <FerramentaGuard flag="alertas"><Alertas /></FerramentaGuard> </Private>  },
      { path: '/alertas/regras', name: 'Configurar Alertas', exact: true, element: <Private> <FerramentaGuard flag="alertas"><AlertasRegras /></FerramentaGuard> </Private>  },
      { path: '/financas/cobranca', name: 'Régua de Cobrança', exact: true, element: <Private> <ReguaCobranca /> </Private>  },
      { path: '/financas/cobranca/historico', name: 'Histórico de Cobranças', exact: true, element: <Private> <ReguaCobrancaHistorico /> </Private>  },
      { path: '/suprimentos/recomendacao', name: 'Sugestão de Compra', exact: true, element: <Private> <RecomendacaoCompra /> </Private>  },
      { path: '/suprimentos/recomendacao/config', name: 'Configurar Sugestão', exact: true, element: <Private> <RecomendacaoConfig /> </Private>  },
      { path: '/inicio/dashboard-preditivo', name: 'Dashboard Preditivo', exact: true, element: <Private> <FerramentaGuard flag="dashboardPreditivo"><DashboardPreditivo /></FerramentaGuard> </Private>  },
      { path: '/inicio/dashboard-preditivo/config', name: 'Configurar Dashboard', exact: true, element: <Private> <FerramentaGuard flag="dashboardPreditivo"><DashboardPreditivoConfig /></FerramentaGuard> </Private>  },
      { path: '/inicio/extensao', name: 'Extensao', exact: true, element: <Private> <Extensao /> </Private>  },
      { path: '/inicio/upgrade', name: 'Upgrade', exact: true, element: <Private> <Upgrade /> </Private>  },
      { path: '/inicio/versao', name: 'Versao', exact: true, element: <Private> <Versao /> </Private>  },
      { path: '/inicio/ajuda', name: 'Ajuda', exact: true, element: <Private> <Ajuda /> </Private>  },
      { path: '/inicio/ferramentas', name: 'Ferramentas', exact: true, element: <Private> <Ferramentas /> </Private>  },
      { path: '/inicio/meu-perfil', name: 'Meu Perfil', exact: true, element: <Private> <MeuPerfil /> </Private>  },
      { path: '/inicio/editar-perfil', name: 'Editar Perfil', exact: true, element: <Private> <EditarPerfil /> </Private>  },

      // Design System (dev-only - só aparece em NODE_ENV !== 'production')
      ...(process.env.NODE_ENV !== 'production'
        ? [{ path: '/design-system', name: 'Design System', exact: true, element: <Private> <DesignSystem /> </Private> }]
        : []),

      // Acesso Negado
      { path: '/acesso-negado', name: 'Acesso Negado', exact: true, element: <Private> <AcessoNegado /> </Private>  },

      //cadastros
      { path: '/cadastros/pessoas', name: 'Pessoas', exact: true, element: <Private> <ProtectedRoute recurso="pessoas" acao="read"><Pessoas /></ProtectedRoute> </Private>  },
      { path: '/cadastros/produtos', name: 'Produtos', exact: true, element: <Private> <ProtectedRoute recurso="produtos" acao="read"><Produtos /></ProtectedRoute> </Private>  },
      { path: '/cadastros/categoria', name: 'Categoria', exact: true, element: <Private> <Categoria /> </Private>  },
      { path: '/cadastros/subcategoria', name: 'Subcategoria', exact: true, element: <Private> <Subcategoria /> </Private>  },
      { path: '/cadastros/marca', name: 'Marca', exact: true, element: <Private> <Marca /> </Private>  },     
      { path: '/cadastros/unidade', name: 'Unidade', exact: true, element: <Private> <Unidade /> </Private>  },
      { path: '/cadastros/embalagem', name: 'Embalagem', exact: true, element: <Private> <Embalagem /> </Private>  },
      { path: '/cadastros/funcionarios', name: 'Funcionarios', exact: true, element: <Private><ProtectedRoute recurso="funcionarios" acao="read"><Funcionarios /></ProtectedRoute></Private> },
      { path: '/cadastros/relatorioscad', name: 'Relatorioscad', exact: true, element: <Private> <Relatorioscad /> </Private>  },

      //suprimentos
      { path: '/suprimentos/estoques', name: 'Estoques', exact: true, element: <Private> <Estoques /> </Private>  },
      { path: '/suprimentos/compras', name: 'Compras', exact: true, element: <Private> <Compras /> </Private>  },
      { path: '/suprimentos/entradas', name: 'Entradas', exact: true, element: <Private> <Entradas /> </Private>  },
      { path: '/suprimentos/entradas/importar', name: 'Importar XML', exact: true, element: <Private> <ImportarXMLEntrada /> </Private> },
      { path: '/suprimentos/entradas/:id', name: 'Detalhe Entrada', exact: true, element: <Private> <EntradaDetalhe /> </Private> },
      { path: '/suprimentos/recebimento', name: 'Recebimento', exact: true, element: <Private> <Recebimento /> </Private>  },
      { path: '/suprimentos/manifesto-destinatario', name: 'Manifesto Destinatário', exact: true, element: <Private> <ManifestoDestinatario /> </Private>  },
      { path: '/suprimentos/relatorios', name: 'Relatorios', exact: true, element: <Private> <Relatorios /> </Private>  },
      { path: '/suprimentos/transferencia', name: 'Transferência', exact: true, element: <Private> <ProtectedRoute recurso="transferencia" acao="read"><Transferencia /></ProtectedRoute> </Private> },
      { path: '/suprimentos/gerenciamento-precos', name: 'Gestão de Preço', exact: true, element: <Private><GerenciamentoPrecos /></Private> },

      //vendas
      { path: '/vendas/pdv', name: 'Pdv', exact: true, element: <Private> <ConfigVendasGuard flag="pdvAtivo"><Pdv /></ConfigVendasGuard> </Private>  },
      { path: '/vendas/pedidos', name: 'Pedidos', exact: true, element: <Private> <Pedidos /> </Private>  },
      { path: '/vendas/ordemservico', name: 'Ordem de Servico', exact: true, element: <Private> <ConfigVendasGuard flag="ordemServicoAtivo"><OrdemServico /></ConfigVendasGuard> </Private>  },
      { path: '/vendas/contratos', name: 'Contratos', exact: true, element: <Private> <ConfigVendasGuard flag="contratoAtivo"><ContratosVenda /></ConfigVendasGuard> </Private>  },
      { path: '/vendas/vendarapida', name: 'Venda Rapida', exact: true, element: <Private> <ConfigVendasGuard flag="vendaRapidaAtivo"><VendaRapida /></ConfigVendasGuard> </Private>  },
      { path: '/vendas/comissoes', name: 'Comissoes', exact: true, element: <Private> <Comissoes /> </Private>  },
      { path: '/vendas/cuponsfiscais', name: 'Cupons Fiscais', exact: true, element: <Private><CuponsFiscais /></Private> },
      { path: '/vendas/relatoriosvendas', name: 'Relatorios', exact: true, element: <Private> <Relatoriosvendas /> </Private>  },  

      //finanças
      { path: '/financas/caixa', name: 'Pdv', exact: true, element: <Private> <Caixa /> </Private>  },
      { path: '/financas/contaspagar', name: 'Contaspagar', exact: true, element: <Private> <Contaspagar /> </Private>  },
      { path: '/financas/contasreceber', name: 'Contasreceber', exact: true, element: <Private> <Contasreceber /> </Private>  },
      { path: '/financas/planoconta', name: 'Planoconta', exact: true, element: <Private> <Planoconta /> </Private>  },
      { path: '/financas/cobrancas', name: 'Cobrancas', exact: true, element: <Private> <Cobrancas /> </Private>  },
      { path: '/financas/extratos', name: 'Extratos', exact: true, element: <Private> <Extratos /> </Private>  },
      { path: '/financas/relatoriosfinancas', name: 'Relatoriosfinancas', exact: true, element: <Private> <Relatoriosfinancas /> </Private>  },
      { path: '/financas/analisecredito', name: 'AnaliseCredito', exact: true, element: <Private> <ConfigLocalStorageGuard storageKey="configFinanceiro" flag="analise_credito_ativo"><AnaliseCredito /></ConfigLocalStorageGuard> </Private>  },
      { path: '/financas/creditoloja', name: 'BaixaCreditoLoja', exact: true, element: <Private> <ConfigLocalStorageGuard storageKey="configCreditoLoja" flag="creditoloja_ativo"><BaixaCreditoLoja /></ConfigLocalStorageGuard> </Private>  },

      //servicos
      { path: '/servicos/contratos', name: 'Contratos', exact: true, element: <Private> <Contratos /> </Private>  },           
      { path: '/servicos/notas', name: 'Notas', exact: true, element: <Private> <Notas /> </Private>  },    
      { path: '/servicos/cobrancasservico', name: 'Cobrancasservico', exact: true, element: <Private> <Cobrancasservico /> </Private>  },    
      { path: '/servicos/relatoriosservico', name: 'Relatoriosservico', exact: true, element: <Private> <Relatoriosservico /> </Private>  },    

      //pcp
      { path: '/pcp/fichatecnica', name: 'Ficha Tecnica', exact: true, element: <Private> <FichaTecnica /> </Private>  },
      { path: '/pcp/ordemproducao', name: 'Ordens de Producao', exact: true, element: <Private> <OrdemProducao /> </Private>  },
      { path: '/pcp/necessidade', name: 'Necessidade de Material', exact: true, element: <Private> <NecessidadeMaterial /> </Private>  },

      //expedição
      { path: '/expedicao/separacao', name: 'Separação', exact: true, element: <Private> <Separacao /> </Private>  },
      { path: '/expedicao/romaneio', name: 'Romaneio', exact: true, element: <Private> <Romaneio /> </Private>  },
      { path: '/expedicao/saida', name: 'Saída de Produto', exact: true, element: <Private> <SaidaProduto /> </Private>  },

      //configuracao
      { path: '/configuracoes', name: 'Configuracões', exact: true, element: <Private> <ProtectedRoute recurso="configuracoes" acao="manage"><Configuracaoes /></ProtectedRoute> </Private>  },
      { path: '/configuracoes/configpcp', name: 'Configuracao PCP', exact: true, element: <Private> <ProtectedRoute modulo="configuracoes"><ConfiguracaoPCP /></ProtectedRoute> </Private>  },
      { path: '/configuracoes/configvendas', name: 'Configuracao Vendas', exact: true, element: <Private> <ProtectedRoute modulo="configuracoes"><ConfiguracaoVendas /></ProtectedRoute> </Private>  },
      { path: '/configuracoes/configproduto', name: 'Configuracao Produto', exact: true, element: <Private> <ProtectedRoute modulo="configuracoes"><ConfiguracaoProduto /></ProtectedRoute> </Private>  },
      { path: '/configuracoes/configexpedicao', name: 'Configuracao Expedicao', exact: true, element: <Private> <ProtectedRoute modulo="configuracoes"><ConfiguracaoExpedicao /></ProtectedRoute> </Private>  },
      { path: '/configuracoes/configempresaefilial', name: 'Empresa e Filial', exact: true, element: <Private> <ProtectedRoute recurso="empresa" acao="update"><Configempresaefilial /></ProtectedRoute> </Private>  },
      { path: '/configuracoes/cadusuariosistema', name: 'Cadusuariosistema', exact: true, element: <Private> <ProtectedRoute recurso="usuarios" acao="read"><Cadusuariosistema /></ProtectedRoute> </Private>  },
      { path: '/configuracoes/configordemcompra', name: 'Configuracaoordemcompra', exact: true, element: <Private> <ProtectedRoute modulo="configuracoes"><Configuracaoordemcompra /></ProtectedRoute> </Private>  },
      { path: '/configuracoes/comissao', name: 'Configuracaocomissao', exact: true, element: <Private> <ProtectedRoute modulo="configuracoes"><Configuracaocomissao /></ProtectedRoute> </Private>  },
      { path: '/configuracoes/configtaxacartao', name: 'Configtaxacartao', exact: true, element: <Private> <ProtectedRoute modulo="configuracoes"><Configtaxacartao /></ProtectedRoute> </Private>  },
      { path: '/configuracoes/configboleto', name: 'Configboleto', exact: true, element: <Private> <ProtectedRoute modulo="configuracoes"><Configboleto /></ProtectedRoute> </Private>  },
      { path: '/configuracoes/configanalisecredito', name: 'ConfigAnaliseCredito', exact: true, element: <Private> <ProtectedRoute modulo="configuracoes"><ConfigAnaliseCredito /></ProtectedRoute> </Private>  },
      { path: '/configuracoes/configcreditoloja', name: 'ConfigCreditoLoja', exact: true, element: <Private> <ProtectedRoute modulo="configuracoes"><ConfigCreditoLoja /></ProtectedRoute> </Private>  },
      { path: '/configuracoes/perfis', name: 'Perfis de Acesso', exact: true, element: <Private> <ProtectedRoute recurso="perfis" acao="read"><Perfis /></ProtectedRoute> </Private>  },
      { path: '/configuracoes/lojas', name: 'Gerenciar Lojas', exact: true, element: <Private> <ProtectedRoute recurso="lojas" acao="read"><GerenciarLojas /></ProtectedRoute> </Private>  },
      { path: '/configuracoes/logauditoria', name: 'Log de Auditoria', exact: true, element: <Private> <ProtectedRoute modulo="configuracoes"><LogAuditoria /></ProtectedRoute> </Private>  },
      { path: '/configuracoes/importacao/produtos', name: 'Importação de Produtos', exact: true, element: <Private> <ProtectedRoute modulo="configuracoes"><ImportacaoProdutos /></ProtectedRoute> </Private>  },
      { path: '/configuracoes/importacao/clientes', name: 'Importacao de Pessoas', exact: true, element: <Private> <ProtectedRoute modulo="configuracoes"><ImportacaoClientes /></ProtectedRoute> </Private>  },
      { path: '/configuracoes/importacao/ncm', name: 'Importacao de NCM', exact: true, element: <Private> <ProtectedRoute modulo="configuracoes"><ImportacaoNCM /></ProtectedRoute> </Private>  },
      { path: '/configuracoes/importacao/pedidovenda', name: 'Importacao de Pedidos de Venda', exact: true, element: <Private> <ProtectedRoute modulo="configuracoes"><ImportacaoPedidoVenda /></ProtectedRoute> </Private>  },
      { path: '/configuracoes/importacao/lista-fornecedor', name: 'Importacao de Lista de Fornecedor', exact: true, element: <Private> <ProtectedRoute modulo="configuracoes"><ImportacaoListaFornecedor /></ProtectedRoute> </Private>  },

      //admin - super admin
      { path: '/admin/clientes', name: 'Gerenciar Clientes', exact: true, element: <Private> <ProtectedRoute recurso="clientes" acao="manage"><GerenciarClientes /></ProtectedRoute> </Private>  },

      //fiscal - configurações
      { path: '/fiscal', name: 'Configurações Fiscais', exact: true, element: <Private> <ConfigFiscalPage /> </Private>  },
      { path: '/fiscal/config-empresa', name: 'Configuração Fiscal Empresa', exact: true, element: <Private> <ConfigFiscalEmpresa /> </Private>  },

      //fiscal - reforma tributária
      { path: '/fiscal/ncm-reforma', name: 'Tabela NCM', exact: true, element: <Private> <NCMReforma /> </Private>  },
      { path: '/fiscal/classtrib-consulta', name: 'Classificação Tributária (IBS/CBS)', exact: true, element: <Private> <ClassTribConsulta /> </Private>  },
      { path: '/fiscal/revisao-tributaria', name: 'Revisão da Classificação Tributária', exact: true, element: <Private> <RevisaoTributaria /> </Private>  },
      { path: '/fiscal/aliquotas-uf', name: 'Alíquotas por UF', exact: true, element: <Private> <AliquotasUF /> </Private>  },

      //fiscal - cadastros base
      { path: '/fiscal/cfop', name: 'CFOP', exact: true, element: <Private> <CFOP /> </Private>  },
      { path: '/fiscal/natureza-operacao', name: 'Natureza de Operação', exact: true, element: <Private> <NaturezaOperacao /> </Private>  },
      { path: '/fiscal/classtrib', name: 'Classificação Tributária', exact: true, element: <Private> <ClassTrib /> </Private>  },
      { path: '/fiscal/cst', name: 'CST', exact: true, element: <Private> <CST /> </Private>  },

      //fiscal - parametrização (legado - manter para compatibilidade)
      { path: '/fiscal/operacoes-fiscais', name: 'Operações Fiscais', exact: true, element: <Private> <OperacoesFiscais /> </Private>  },
      { path: '/fiscal/regra-icms-uf', name: 'Regras ICMS UF', exact: true, element: <Private> <RegraICMSUF /> </Private>  },

      //fiscal - nota fiscal eletrônica
      { path: '/fiscal/nfe', name: 'Nota Fiscal Eletrônica', exact: true, element: <Private> <NotaFiscalEletronica /> </Private>  },

      //fiscal - NFS-e (Padrão Nacional)
      { path: '/fiscal/nfse', name: 'NFS-e Padrão Nacional', exact: true, element: <Private> <NotaFiscalServico /> </Private>  },

      //fiscal - dashboard e relatórios
      { path: '/fiscal/dashboard', name: 'Dashboard Fiscal', exact: true, element: <Private> <DashboardFiscal /> </Private>  },
      { path: '/fiscal/diagnostico-produtos', name: 'Diagnostico Fiscal', exact: true, element: <Private> <DiagnosticoFiscal /> </Private>  },
      { path: '/fiscal/regras-conversao', name: 'Regras de Conversão', exact: true, element: <Private> <RegrasConversao /> </Private> },
      { path: '/fiscal/inutilizacao', name: 'Inutilização de Numeração', exact: true, element: <Private> <InutilizacaoNumeracao /> </Private> },
      { path: '/fiscal/relatorio-nfe', name: 'Relatório de NF-e', exact: true, element: <Private> <RelatorioNFe /> </Private>  },
      { path: '/fiscal/relatorio-nfce', name: 'Relatório de NFC-e', exact: true, element: <Private> <RelatorioNFCe /> </Private>  },

      //suporte
      { path: '/suporte/suporte', name: 'Suporte', exact: true, element: <Private> <Suporte /> </Private>  },

      { path: '*', element: <Navigate to="/auth/404" /> },
    ],
  },
  {
    path: '/auth',
    element: <BlankLayout />,
    children: [
      { path: '404', element: <Error /> },
      { path: '*', element: <Navigate to="/auth/404" /> },
      { path: 'registerformik', element: <RegisterFormik /> },
      { path: 'loginformik', element: <LoginFormik /> },
      { path: 'maintanance', element: <Maintanance /> },
      { path: 'lockscreen', element: <LockScreen /> },
      { path: 'RecoverPassword', element: <RecoverPassword /> },
    ],
  },
];

Private.propTypes = {
  children: PropTypes.node.isRequired,
};

PrivateLogin.propTypes = {
  children: PropTypes.node.isRequired,
};

export { NotaFiscalEletronica };
export default ThemeRoutes;
